import { render, staticRenderFns } from "./platformCoupon.vue?vue&type=template&id=eda49a84"
import script from "./platformCoupon.vue?vue&type=script&lang=js"
export * from "./platformCoupon.vue?vue&type=script&lang=js"
import style0 from "./platformCoupon.vue?vue&type=style&index=0&id=eda49a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports